module.exports = __webpack_public_path__ + "static/54invgde-89859c84cc8d3dcf9f85ff825daf4d7a.gif";